export default __webpack_public_path__ + "static/media/bed.70845700.png";